export default __webpack_public_path__ + "static/media/htplogo_v3.354b4c4d.svg";